// extracted by mini-css-extract-plugin
export default {"indochine":"#cf7800","loot":"Bc","loot-chance":"Bd","lootChance":"Bd","loot-from":"Be","lootFrom":"Be","loot-name":"Bf","lootName":"Bf","title":"Bg","wrapper":"Bh"};